import React from 'react';
import { Mail, MapPin, Phone, Send } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const Kontakt = () => {
  const handleMailto = () => {
    window.location.href = 'mailto:hdgdr@icloud.com';
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-brand-900 mb-6">
              Lassen Sie uns sprechen
            </h1>
            <p className="text-xl text-brand-600 max-w-3xl mx-auto">
              Wir freuen uns auf Ihre Anfrage und beraten Sie gerne zu Ihrem Projekt.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-brand-900 mb-6">
                  DR. GRASSL & Coll.
                </h2>
                <p className="text-lg text-brand-600 mb-8">
                  Geprüfter Sachverständiger & Rating Advisor (TÜV)
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-6 bg-brand-50 rounded-xl hover:bg-brand-100 transition-colors">
                  <MapPin className="w-6 h-6 text-brand-700 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-brand-900 mb-1">Adresse</h3>
                    <p className="text-brand-600">
                      Bahnhofstraße 8<br />
                      26316 Varel
                    </p>
                  </div>
                </div>

                <div 
                  onClick={handleMailto}
                  className="flex items-start space-x-4 p-6 bg-brand-50 rounded-xl hover:bg-brand-100 transition-colors cursor-pointer group"
                >
                  <Mail className="w-6 h-6 text-brand-700 flex-shrink-0 mt-1 group-hover:text-brand-900" />
                  <div>
                    <h3 className="font-semibold text-brand-900 mb-1">E-Mail</h3>
                    <p className="text-brand-600 group-hover:text-brand-900 group-hover:underline">
                      hdgdr@icloud.com
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-8 bg-brand-900 text-white rounded-xl">
                <h3 className="text-2xl font-bold mb-4">Unsere Expertise</h3>
                <ul className="space-y-3">
                  <li className="flex items-center space-x-2">
                    <span className="w-2 h-2 bg-white rounded-full"></span>
                    <span>Bauschaden-Sachverständigenwesen</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <span className="w-2 h-2 bg-white rounded-full"></span>
                    <span>Immobilienbewertung</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <span className="w-2 h-2 bg-white rounded-full"></span>
                    <span>Investments</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <span className="w-2 h-2 bg-white rounded-full"></span>
                    <span>Feuchte- und Nässegutachten</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form Area */}
            <div className="bg-brand-50 rounded-2xl p-8 lg:p-12">
              <h2 className="text-3xl font-bold text-brand-900 mb-6">
                Kontakt aufnehmen
              </h2>
              <p className="text-brand-600 mb-8">
                Klicken Sie auf den Button unten, um uns eine E-Mail zu senden. 
                Wir melden uns schnellstmöglich bei Ihnen zurück.
              </p>

              <div className="space-y-8">
                <div className="p-6 bg-white rounded-xl border-2 border-brand-200">
                  <h3 className="font-semibold text-brand-900 mb-3">
                    Was sollte Ihre Nachricht enthalten?
                  </h3>
                  <ul className="space-y-2 text-brand-600">
                    <li className="flex items-start space-x-2">
                      <span className="text-brand-900 mt-1">•</span>
                      <span>Art der gewünschten Leistung</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-brand-900 mt-1">•</span>
                      <span>Kurze Beschreibung Ihres Projekts</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-brand-900 mt-1">•</span>
                      <span>Ihre Kontaktdaten (Telefon optional)</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-brand-900 mt-1">•</span>
                      <span>Gewünschter Zeitrahmen</span>
                    </li>
                  </ul>
                </div>

                <div className="pt-2">
                <Button 
                  onClick={handleMailto}
                  size="lg" 
                  className="w-full bg-brand-900 hover:bg-brand-800 text-white px-8 py-3 text-lg transition-all duration-300 hover:shadow-lg"
                >
                  <Mail className="mr-2 w-5 h-5" />
                  E-Mail senden
                </Button>
                </div>

                <p className="text-sm text-brand-500 text-center">
                  Wir antworten in der Regel innerhalb von 24 Stunden
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">
              Vertrauen durch Erfahrung
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-xl shadow-sm">
              <div className="text-4xl md:text-5xl font-bold text-brand-900 mb-2">40+</div>
              <div className="text-brand-600 font-medium">Jahre in der Immobilienbranche</div>
            </div>
            <div className="text-center p-8 bg-white rounded-xl shadow-sm">
              <div className="text-4xl md:text-5xl font-bold text-brand-900 mb-2">500+</div>
              <div className="text-brand-600 font-medium">Realisierte Projekte</div>
            </div>
            <div className="text-center p-8 bg-white rounded-xl shadow-sm">
              <div className="text-4xl md:text-5xl font-bold text-brand-900 mb-2">~100M</div>
              <div className="text-brand-600 font-medium">EUR Verwaltetes Volumen</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Kontakt;
